<script setup></script>

<template>
    <!-- footer area -->
    <footer class="footer-area">
        <div class="footer-shape">
            <img src="images/01_1.png" alt="">
        </div>
        <div class="footer-widget d-none">
            <div class="container">
                <div class="row footer-widget-wrapper pt-100 pb-70">
                    <div class="col-md-6 col-lg-5">
                        <div class="footer-widget-box about-us">
                            <a href="#" class="footer-logo">
                                <img src="csiicon.png" style="width: 50px;" alt="">
                            </a>
                            <p class="mb-3">
                                We are many variations of passages available majority have suffered
                                in some injected content of a page when looking at its layout humour words believable.
                            </p>
                            
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-2">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Quick Links</h4>
                            <ul class="footer-list">
                                <li><a href="about.html"><i class="fas fa-caret-right"></i> About Us</a></li>
                                <li><a href="blog.html"><i class="fas fa-caret-right"></i> Update News</a></li>
                                <li><a href="contact.html"><i class="fas fa-caret-right"></i> Contact Us</a></li>
                                <li><a href="testimonial.html"><i class="fas fa-caret-right"></i> Testimonials</a></li>
                                <li><a href="terms.html"><i class="fas fa-caret-right"></i> Terms Of Service</a></li>
                                <li><a href="privacy.html"><i class="fas fa-caret-right"></i> Privacy policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-2">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Our Social</h4>
                            <ul class="footer-list social">
                                <li><a href="#"><i class="fab fa-facebook"></i> Facebook</a></li>
                                <li><a href="#"><i class="fab fa-x-twitter"></i> Twitter</a></li>
                                <li><a href="#"><i class="fab fa-instagram"></i> Instagram</a></li>
                                <li><a href="#"><i class="fab fa-youtube"></i> Youtube</a></li>
                                <li><a href="#"><i class="fab fa-whatsapp"></i> Whatsapp</a></li>
                                <li><a href="#"><i class="fab fa-linkedin-in"></i> Linkedin</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <div class="footer-widget-box list">
                            <h4 class="footer-widget-title">Get In Touch</h4>
                            <ul class="footer-contact">
                                <li><a href="tel:+21236547898"><i class="far fa-phone"></i>+2 123 654 7898</a></li>
                                <li><i class="far fa-map-marker-alt"></i>25/B Milford Road, New York</li>
                                <li><a href="/cdn-cgi/l/email-protection#046d6a626b44617c65697468612a676b69"><i
                                            class="far fa-envelope"></i><span class="__cf_email__"
                                            data-cfemail="c3aaada5ac83a6bba2aeb3afa6eda0acae">[email�protected]</span></a>
                                </li>
                            </ul>
                            <div class="footer-request">
                                <!-- <p>Book Your Ticket</p>
                                <a href="#" class="theme-btn">Buy Ticket<i class="fas fa-arrow-right"></i></a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="copyright">
                <div class="row">
                    <div class="col-md-6 align-self-center">
                        <p class="copyright-text">
                            All Rights Reserved.
                        </p>
                    </div>
                    <div class="col-md-6 align-self-center">
                        <ul class="footer-menu">
                            <!-- <li><a href="contact.html">Support</a></li> -->
                            <!-- <li><a href="terms.html">Terms Of Services</a></li> -->
                            <li><a href="/">CSI Experience</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- footer area end -->
</template>

<style></style>